export function temConteudo(valor) {
  if (valor === null || valor === undefined || valor === '') return false;
  if (Array.isArray(valor)) return valor.some(temConteudo);
  if (typeof valor === 'object') return Object.values(valor).some(temConteudo);
  return true;
}
